import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Pass actions</Typography>
    <p>Use this page to perform managed-pass actions when the Smartix Scan app is not being used, for example for an assisted sale or an online transaction.</p>
    <Typography variant='h5'>Available actions</Typography>
    <p>The actions depend on the pass type. Examples include admitting an event pass, adding or redeeming loyalty points, adding or removing stamp-card stamps, and debiting or refunding a gift-card balance.</p>
    <Typography variant='h5'>Before submitting</Typography>
    <p>Review the pass identifier, amount and action carefully. Actions are recorded in Scan History and may update the wallet pass immediately.</p>
  </div>
)

export default HelpText
